<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  export default {
    name: 'EditorialModule',
    props: {
      options: {
        type: Object,
        default: _ => {},
      },
    },
    methods: {
      getAlignmentClass(alignment) {
        return alignment === 'left' ? 'text-left' : alignment === 'right' ? 'text-right' : 'text-center'
      },
    },
  }
</script>
